export function getFilteredAppsList(_list, filter, installed_app_id) {
  let list =
    filter === 'directory'
      ? _list
      : _list.filter(item => item.companies?.[0]?.status === 'granted')

  if (!installed_app_id) return list

  return [...list].sort((a, b) => (a.id === installed_app_id ? -1 : 1))
}
